import React from 'react';

interface MobileSearchProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
}

const MobileSearch: React.FC<MobileSearchProps> = ({ 
  value, 
  onChange, 
  placeholder = "Rechercher...",
  className = ""
}) => {
  return (
    <div className={`bg-white shadow-sm border border-gray-200 rounded-lg p-4 ${className}`}>
      <div className="relative">
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          <span className="text-gray-400 text-lg">🔍</span>
        </div>
        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="block w-full pl-10 pr-3 py-3 border border-gray-300 rounded-lg text-base focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          placeholder={placeholder}
        />
        {value && (
          <button
            onClick={() => onChange('')}
            className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600"
          >
            <span className="text-lg">✕</span>
          </button>
        )}
      </div>
    </div>
  );
};

export default MobileSearch;
